import request from '../utils/request'

/**
 * 购物车相关接口
 */

// 获取购物车列表
export function getCartList() {
  return request({
    url: '/h5/cart/list',
    method: 'get'
  })
}

// 获取购物车数量
export function getCartCount() {
  return request({
    url: '/h5/cart/count',
    method: 'get'
  })
}

// 添加商品到购物车
export function addToCart(data) {
  return request({
    url: '/h5/cart/add',
    method: 'post',
    data
  })
}

// 更新购物车商品数量/选中状态
export function updateCart(data) {
  return request({
    url: '/h5/cart/update',
    method: 'put',
    data
  })
}

// 删除购物车商品
export function deleteCart(id) {
  return request({
    url: `/h5/cart/delete/${id}`,
    method: 'post'
  })
}

// 清空购物车
export function clearCart() {
  return request({
    url: '/h5/cart/clear',
    method: 'delete'
  })
}
export function updateCartNum(req){
  return request({
    url:`/h5/cart/updateCartNum/${req.id}/${req.num}`,
    method:'get',
    // params:req
    // data:req
  })
}